
import { defineComponent, onUnmounted, watch, computed } from "vue";

export default defineComponent({
  props: {
    show: {
      default: false,
    },
    maxWidth: {
      default: "2xl",
    },
    closeable: {
      default: true,
    },
  },
  emits: ["shown", "close"],
  setup(props, { emit }) {
    const close = () => {
      if (props.closeable) {
        document.body.style.overflow = "";
        emit("close");
      }
    };
    const shown = () => {
      emit("shown");
    };

    const closeOnEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && props.show) {
        close();
      }
    };

    const maxWidthClass = computed((): string => {
      const options: { [key: string]: string } = {
        sm: "sm:max-w-sm",
        md: "sm:max-w-md",
        lg: "sm:max-w-lg",
        xl: "sm:max-w-xl",
        "2xl": "sm:max-w-2xl",
        "4xl": "sm:max-w-4xl",
      };
      return options[props.maxWidth];
    });

    document.addEventListener("keydown", closeOnEscape);

    onUnmounted(() => {
      document.removeEventListener("keydown", closeOnEscape);
    });

    watch(
      () => props.show,
      (newVal) => {
        if (newVal) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "";
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      maxWidthClass,
      close,
      shown,
    };
  },
});
